import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export const LOADING_VIDEO_URL = `${process.env.PUBLIC_URL || ''}/animation_loading.mp4`;

const LoadingAnimation = ({ sx = {}, restart = false }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!restart) return undefined;
    const video = videoRef.current;
    if (!video) return undefined;
    video.currentTime = 0;
    video.play().catch(() => {});
    return undefined;
  }, [restart]);

  return (
    <Box
      component="video"
      ref={videoRef}
      src={LOADING_VIDEO_URL}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      aria-hidden
      sx={{
        width: { xs: 320, sm: 440, md: 560 },
        maxWidth: 'min(95vw, 600px)',
        height: 'auto',
        display: 'block',
        objectFit: 'contain',
        ...sx,
      }}
    />
  );
};

export default LoadingAnimation;
